<template>
    <div
        id="lt-yantr"
        class="advanced-calc fha-loan-calc">
        <div class="container">
            <div class="advanced-calc-filter">
                <ul class="filter-inputs four-col">
                    <li class="zip-code-input">
                        <label>{{ labelPropertyLocation }}</label>
                        <zip-code-input
                            v-model="ZipCode"
                            :autofocus="true"
                            @input="getLocationByZip"
                        />
                        <span
                            v-show="ShowZipCodeError"
                            class="error-msg">Please enter a valid zip code.</span>
                        <div
                            v-show="!ShowZipCodeError"
                            class="address">
                            <span class="lt4-MapPin"></span> {{ Location.city + ', ' + Location.state }}
                        </div>
                    </li>
                    <li>
                        <number-input
                            v-model="HomePrice"
                            :label="labelHomePrice"
                            inputmode="decimal"
                            @input="calculateByHomePrice()"
                        />
                        <span class="sub-content">
                            <small>Max Loan Amount:</small>
                            <small class="blue-text">${{ currencyWholeNumber(MaxDownPayment) }}</small>
                            <lt-label
                                :span="span"
                                :tooltip-link="tooltipLoanLimit"
                            />
                        </span>
                    </li>
                    <li>
                        <number-input
                            v-model="DownPayment"
                            :label="labelDownPayment"
                            inputmode="decimal"
                            @input="restrictDownPaymentValue"
                            @inputBlur="calculateByDownPayment"
                        />
                        <span
                            v-if="maxDownpaymentError"
                            class="error-msg">Please enter no more than 16 characters.</span>
                        <span class="sub-content">
                            <small>Min. Required 3.5% </small>
                            <lt-label
                                :span="span"
                                :tooltip-link="tooltipMinDownPayment"
                            />
                        </span>
                    </li>
                    <li class="percentage-input">
                        <number-input
                            v-model="DownPaymentPercent"
                            symbol="%"
                            symbol-aligned="right"
                            precision="2"
                            max-value="100.000"
                            inputmode="decimal"
                            @input="getDownPaymentPercentChange()"
                            @inputBlur="calculateByDownPercentage"
                        />
                    </li>
                    <li class="loantype-section">
                        <drop-down
                            v-model="LoanType"
                            :label="labelLoanType"
                            :options="LoanTermInYearsList"
                            @input="calulatePayment()"
                        />
                    </li>
                    <li class="mortgage-rate-section">
                        <number-input
                            v-model="MortgageRate"
                            :label="labelMortgageRate"
                            symbol="%"
                            symbol-aligned="right"
                            precision="3"
                            max-value="100.000"
                            inputmode="decimal"
                            @input="calulatePayment()"
                        />
                        <a
                            href="/home/mortgage/rates/"
                            target="_blank"
                            class="font-sm lh-normal">Check out current mortgage rates</a>
                    </li>
                    <li class="percentage-amt">
                        <number-input
                            v-model="PropertyTaxes"
                            :label="labelPropertyTaxes"
                            symbol="/yr"
                            symbol-aligned="right"
                            inputmode="decimal"
                            @input="setPropertyTaxesAndPercent($event)"
                        />
                    </li>

                    <li class="percentage-input">
                        <number-input
                            v-model="PropertyTaxesPercent"
                            symbol="%"
                            symbol-aligned="right"
                            precision="2"
                            max-value="100.000"
                            inputmode="decimal"
                            @input="getPropertyTaxesPercentChange($event)"
                        />
                    </li>
                    <li>
                        <number-input
                            v-model="HomeInsurance"
                            :label="labelHomeInsurance"
                            symbol="/yr"
                            symbol-aligned="right"
                            inputmode="decimal"
                            @input="calulatePayment()"
                        />
                        <span
                            v-show="maxHomeInsuranceError"
                            class="error-msg">Please enter no more than 16 characters.</span>
                    </li>
                </ul>
                <!-- Advanced Options start -->

                <a
                    v-show="ShowAdvancedOptions"
                    href="javascript:void(0)"
                    class="reset-calc"
                    @click="resetFilter()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
            </div>
            <div
                v-if="CreditScore != '3'"
                class="calculation-section">
                <div class="top-section">
                    <h3>How Your FHA Loan Breaks Down</h3>
                    <ul class="calc-box three-box">
                        <li>
                            <label>FHA Base Loan Amount</label>
                            <h3
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(Loanamount)}">
                                ${{ convertCurrency(Loanamount) }}
                            </h3>
                        </li>
                        <li>
                            <label>Upfront MIP (1.75%) <lt-label
                                :span="span"
                                :tooltip-link="tooltipFhaUpfrontMip"
                            /></label>
                            <h3
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(UpfrontMIP)}">
                                ${{ convertCurrency(UpfrontMIP) }}
                            </h3>
                        </li>
                        <li>
                            <label>Total Loan Amount</label>
                            <h3
                                class="value"
                                :class="{ 'red-text': isNegativeAmount(TotalLoanAmount)}">
                                ${{ convertCurrency(TotalLoanAmount) }}
                            </h3>
                        </li>
                    </ul>
                    <lt-logo v-if="ltLogo==1">
                        <small>NMLS#1136 Terms & Conditions Apply</small>
                    </lt-logo>
                </div>
                <div class="bottom-section text-center">
                    <h3>Monthly Payment Breakdown</h3>
                    <div class="chart-parent">
                        <vue-chart
                            id="donutChart"
                            type="doughnut"
                            :data="chartData"
                            :options="options"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                        <div class="donut-inner">
                            <label>Total Monthly Payment</label>
                            <h3 :class="{ 'red-text': isNegativeAmount(TotalMoPayment)}">
                                ${{ convertCurrency(TotalMoPayment) }}
                            </h3>
                        </div>
                    </div>
                    <div class="monthly-budget">
                        <ul class="list-unstyled summary">
                            <li>
                                <label><span class="green-bg"></span> Principal & Interest</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoPrincipalInterest)}">${{ convertCurrency(MoPrincipalInterest) }}</span>
                            </li>
                            <li>
                                <label><span class="darkgreen-bg"></span> Property Taxes</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoPropertyTaxes)}">${{ convertCurrency(MoPropertyTaxes) }}</span>
                            </li>
                            <li>
                                <label><span class="blue-bg"></span> Home Insurance</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoHomeInsurance)}">${{ convertCurrency(MoHomeInsurance) }}</span>
                            </li>
                            <li>
                                <label><span class="darkgray-bg"></span> Monthly FHA MIP <lt-label
                                    :span="span"
                                    :tooltip-link="tooltipFhaMonthlyMip"
                                /> </label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount(MoFhaPmi)}">${{ convertCurrency(MoFhaPmi) }}</span>
                            </li>
                        </ul>
                        <div class="clear-fix"></div>
                        <div class="view-free-offers">
                            <h4>We’ve found offers for this result:</h4>
                            <button
                                class="btn btn-blue"
                                type="submit"
                                @click="redirect()">
                                {{ DestinationButtonText }}
                            </button>
                        </div>
                        <div>
                            <advertising-disclosures
                                v-if="DisclosureText"
                                :disclosure-text="DisclosureText"
                                :disclosure-tokens="DisclosureTokens"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="low-credit-score">
                <div class="credit-score-msg">
                    <h4>Sorry, FHA Loans require a minimum credit score of 500</h4>
                    <h4>It looks like a FHA Loan isn't the best solution for your financial situation. Not to worry, though. We have other resources just for you!</h4>
                    <a
                        href="https://spring.lendingtree.com/enroll"
                        target="_blank">Knowledge is power. Get your credit score free now</a>
                </div>
                <ul class="credit-score-info">
                    <li>
                        <i class="lt4-CreditRepair"></i>
                        <h5>Credit repair services</h5>
                        <p>
                            When looking into <a
                                href="/credit-repair/"
                                target="_blank">services to repair and improve your credit</a>, it's important to research as much as possible. You want to make sure you identify and avoid any scams and protect yourself. You can learn more at What You Need to Know About Credit Repair Services.
                        </p>
                        <a
                            href="/credit-repair/what-you-need-to-know-about-credit-repair-services/"
                            target="_blank"
                            class="btn btn-blue">Learn More</a>
                    </li>
                    <li>
                        <i class="lt4-CreditCards"></i>
                        <h5>How to build credit</h5>
                        <p>Perhaps you're just starting out on your own and need to build your credit. Luckily, you can start establishing credit by starting small – such as opening up a student credit card or putting some bills in your own name. Make sure to pay every single bill on time and get in the habit of monitoring your credit score regularly. You can learn more on how to build credit from scratch here.</p>
                        <a
                            href="/credit-repair/how-to-build-credit-from-scratch/"
                            target="_blank"
                            class="btn btn-blue">Learn More</a>
                    </li>
                    <li>
                        <i class="lt4-CreditScore"></i>
                        <h5>Improve your credit</h5>
                        <p>You can improve your credit by paying all of your bills on time, using your credit card wisely, disputing any errors on your credit report, and keeping your credit card balances low. For more, see Simple Ways to Improve Your Credit Rating.</p>
                        <a
                            href="credit-repair/how-to-improve-your-credit-score/"
                            target="_blank"
                            class="btn btn-blue">Learn More</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import VueChart from 'vue-chart-js';
    import Accounting from 'accounting';
    import VueScrollTo from 'vue-scrollto';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import LoanTermList from '~/constants/loan-term-list';
    import CreditScoreList from '~/constants/credit-score-list';
    import LtLabel from '~/components/lt-label.vue';
    import ChartTooltip from '~/helpers/chart-tooltip';
    import PaymentHelper from '~/helpers/payment';
    import BaseMixin from '~/mixin/base-mixin';
    import LtLogo from '~/components/lt-logo.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import StringFormat from '~/helpers/string-format';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import LimitsFromZipByCode from '~/services/graphql/LimitsFromZipByCode.gql';
    import GraphQLMixin from '~/mixin/graphql';
    import { getFinancialApiUrl, setHeader } from '~/helpers/financialapi-url-env';

    export default {
        components: {
            NumberInput,
            DropDown,
            LtLabel,
            VueChart,
            LtLogo,
            AdvertisingDisclosures,
            ZipCodeInput,
        },
        directives: {
            VueScrollTo,
        },
        mixins: [BaseMixin, GraphQLMixin, GetLocation],
        props: {
            labelHomePrice: {
                default: 'Home Price:',
            },
            labelDownPayment: {
                default: 'Down Payment:',
            },
            labelCreditScore: {
                default: 'Est. Credit Score:',
            },
            labelLoanType: {
                default: 'Loan Term:',
            },
            labelMortgageRate: {
                default: 'Mortgage Rate:',
            },
            labelPropertyTaxes: {
                default: 'Property Taxes:',
            },
            labelHomeInsurance: {
                default: 'Home Insurance:',
            },
            labelHOAFees: {
                default: 'HOA Fees:',
            },
            homePrice: {
                default: 250000,
            },
            downPayment: {
                default: 8750,
            },
            creditScore: {
                default: 1,
            },
            loanType: {
                default: 30,
            },
            mortgageRate: {
                default: 6.5,
            },
            propertyTaxes: {
                default: 1.25,
            },
            homeInsurance: {
                default: 800,
            },
            hoaFees: {
                default: 0,
            },
            tooltipDownPayment: {
                default: 'down-payment',
            },
            tooltipLoanLimit: {
                default: 'fha-loan-limit',
            },
            tooltipMinDownPayment: {
                default: 'fha-down-payment',
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            howToUseCalculator: {
                default: 1,
            },
            labelPropertyLocation: {
                default: 'Property Location:',
            },
            geoLocation: {
                type: Object,
                default() {
                    return {
                        zipCode: '28277',
                        city: 'Charlotte',
                        state: 'NC',
                    };
                },
            },
            showAdvancedOptions: {
                default: true,
            },
            customizeButtonText: {
                default: 'Customize',
            },
            recalculateButtonText: {
                default: 'Recalculate',
            },
            totalMoPayment: {
                default: 1953,
            },
            tooltipFhaUpfrontMip: {
                default: 'fha-upfront-mip',
            },
            tooltipFhaMonthlyMip: {
                default: 'fha-monthly-mip',
            },
            moPrincipalInterest: {
                default: 1340,
            },
            moPropertyTaxes: {
                default: 300,
            },
            moHomeInsurance: {
                default: 67,
            },
            moHoaFees: {
                default: 0,
            },
            moFhaPmi: {
                default: 246,
            },
            destinationLinkOrId: {
                default: 'ns-calc-fha',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            propertyTaxesPercent: {
                default: 1.20,
            },
            graphQlUri: {
                default: '',
            },
            downPaymentPercent: {
                default: 3.5,
            },
        },
        data() {
            return {
                ZipCode: this.geoLocation.zipCode,
                ShowZipCodeError: false,
                Location: this.geoLocation,
                HomePrice: this.homePrice,
                DownPayment: this.downPayment,
                CreditScore: this.creditScore,
                LoanType: this.loanType,
                MortgageRate: this.mortgageRate,
                PropertyTaxes: this.propertyTaxes,
                HomeInsurance: this.homeInsurance,
                HOAFees: this.hoaFees,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowAdvancedOptions: this.showAdvancedOptions,
                CustomizeButtonText: this.customizeButtonText,
                RecalculateButtonText: this.recalculateButtonText,
                TotalMoPayment: this.totalMoPayment,
                CreditScoreList: CreditScoreList.fhaLoan,
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.fhaloantype,
                MoPrincipalInterest: this.moPrincipalInterest,
                MoPropertyTaxes: this.moPropertyTaxes,
                MoHomeInsurance: this.moHomeInsurance,
                MoHoaFees: this.moHoaFees,
                MoFhaPmi: this.moFhaPmi,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                span: '',
                HomePriceLimit: 0,
                LoanLimit: 0,
                MaxDownPayment: 0,
                MinDownPayment: 0,
                HomePriceAsNumber: this.homeprice,
                DownPaymentAsNumber: this.downPayment,
                Loanamount: 0,
                UpfrontMIP: 0,
                TotalLoanAmount: 0,
                maxDownpaymentError: false,
                maxHoaError: false,
                maxHomeInsuranceError: false,
                PropertyTaxesPercent: this.propertyTaxesPercent,
                InitialPropertyTax: this.PropertyTaxes,
                GraphQlUri: this.graphQlUri,
                DownPaymentPercent: this.downPaymentPercent,
                // Setting for chart
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            backgroundColor: [
                                '#08C177',
                                '#078181',
                                '#00AEEF',
                                '#101F30',
                            ],
                            borderWidth: 0,
                        },
                    ],
                },
                options: {
                    cutoutPercentage: 89,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                        custom: ChartTooltip.customTooltips,
                    },
                },
                chartWidth: 200,
                chartHeight: 130,
                CurrentDate: new Date(),
            };
        },
        watch: {
            HomePrice() {
                this.InitializeData();
            },
            PropertyTaxes() {
                if (this.unformat(this.PropertyTaxes) > this.unformat(this.HomePrice)) {
                    this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                    this.setPropertyTaxesAndPercent(this.PropertyTaxes);
                }
                this.calulatePayment();
            },
            PropertyTaxesPercent() {
                if (this.unformat(this.PropertyTaxesPercent) > 100) {
                    this.PropertyTaxesPercent = 100.00;
                    this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                }
            },
        },
        mounted() {
            this.GraphQlUri = this.graphQlUri !== '' ? this.graphQlUri : getFinancialApiUrl();
            this.createGraphQlClient(this.GraphQlUri, setHeader);
            this.getLocationByZip(this.ZipCode);
            this.calculateByHomePrice();
            this.InitializeData();
        },
        methods: {
            InitializeData() {
                this.getPropertyTaxesPercentChange(this.PropertyTaxesPercent);
            },
            calculateAndViewMore() {
                this.viewMoreClick();
            },
            capitalize(value) {
                if (!value) {
                    return '';
                }
                return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
            },
            currencyFilterWithPrecision(figure) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision: 2 }) : 0;
            },
            currencyWholeNumber(figure) {
                return figure > 0 ? Accounting.formatNumber(figure) : 0;
            },
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.isZipCodeValidFormat(zip)) {
                    GetLocation.methods.GetZipCode(zip, this.setLocationData);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            isZipCodeValidFormat(zip) {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(zip) && zip !== '';
            },
            setLocationData(geoData) {
                const isError = 'err' in geoData && geoData.err === true;
                if (isError) {
                    this.ShowZipCodeError = true;
                } else {
                    const cityNameFormatted = StringFormat.capitalize(geoData.city);
                    geoData.city = cityNameFormatted;
                    this.Location = geoData;
                    this.ShowZipCodeError = false;
                    this.getFhaLimit();
                }
            },
            async getFhaLimit() {
                const variables = {
                    zip: this.ZipCode,
                    soaCode: '203B',
                };
                try {
                    const data = await this.graphQlQuery(LimitsFromZipByCode, variables);
                    const { limits } = data;
                    if (limits !== undefined) {
                        const limit = limits.limit1LivingUnit != null ? limits.limit1LivingUnit : 0;
                        this.updateLoanLimit(limit);
                    }
                } catch (e) {
                    console.warn(`Error getting county loan limits: ${e}`);
                }
            },
            viewMoreClick() {
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },
            calulatePayment() {
                if (this.HomePriceAsNumber >= 0) {
                    this.PropertyTaxesPercent = this.PropertyTaxesPercent > 100 ? 100 : this.PropertyTaxesPercent;
                    this.MortgageRate = this.MortgageRate > 100 ? 100 : this.MortgageRate;
                    let pmi;
                    let mortgageInsurancePremium;
                    const homeprice = this.HomePriceAsNumber;
                    const downpayment = this.DownPaymentAsNumber;
                    const rate = this.MortgageRate / 1200;
                    const loanterm = this.LoanType * 12;
                    const hoa = this.HOAFees / 12;
                    const hoi = this.HomePriceAsNumber > 0 ? this.HomeInsurance / 12 : 0;
                    const proptaxrate = this.PropertyTaxesPercent / 1200;
                    const loanamount = homeprice - downpayment;
                    const proptax = homeprice * proptaxrate;
                    const upfrontMIP = Math.round(loanamount * 0.0175);
                    this.Loanamount = loanamount;
                    this.UpfrontMIP = upfrontMIP;
                    this.TotalLoanAmount = upfrontMIP + loanamount;
                    const newPi = PaymentHelper.compute_PMT(this.TotalLoanAmount, rate, loanterm);
                    if (parseInt(this.LoanType, 10) <= 15) {
                        mortgageInsurancePremium = 0.40;
                    } else {
                        mortgageInsurancePremium = 0.55;
                    }
                    pmi = this.Loanamount * mortgageInsurancePremium / 100 / 12;

                    this.MoPrincipalIntestrest = !isNaN(newPi) ? Math.round(newPi) : 0;
                    this.MoPropertyTaxes = Math.round(proptax);
                    this.MoHomeInsurance = Math.round(hoi);
                    this.MoHoaFees = Math.round(hoa);
                    this.MoFhaPmi = Math.round(pmi);
                    this.chartData.datasets[0].data = [];
                    this.chartData.labels = [];
                    this.TotalMoPayment = this.MoPrincipalInterest + this.MoPropertyTaxes + this.MoHomeInsurance + this.MoHoaFees + this.MoFhaPmi;
                    this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoPrincipalInterest, this.TotalMoPayment));
                    this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoPropertyTaxes, this.TotalMoPayment));
                    this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoHomeInsurance, this.TotalMoPayment));
                    this.chartData.datasets[0].data.push(this.calculatePercentage(this.MoFhaPmi, this.TotalMoPayment));
                    this.chartData.labels.push(`Principal & Interest ${Accounting.formatMoney(this.MoPrincipalInterest, { precision: 0 })}`);
                    this.chartData.labels.push(`Property Taxes ${Accounting.formatMoney(this.MoPropertyTaxes, { precision: 0 })}`);
                    this.chartData.labels.push(`Homeowner's Insurance ${Accounting.formatMoney(this.MoHomeInsurance, { precision: 0 })}`);
                    this.chartData.labels.push(`FHA Annual MIP (0.85%) ${Accounting.formatMoney(this.MoFhaPmi, { precision: 0 })}`);
                    this.maxHoaError = this.HOAFees.toString().length >= 16;
                    this.maxHomeInsuranceError = this.HomeInsurance.toString().length >= 16;
                }
            },
            calculatePercentage(value, divider) {
                return Math.round(value / divider * 100);
            },
            updateLoanLimit(limit) {
                this.LoanLimit = limit;
                this.MaxDownPayment = this.LoanLimit;
                this.HomePriceLimit = Math.round(this.LoanLimit * 0.9825 / 0.965);
                this.updateHomepriceDetails();
            },
            updateHomepriceDetails() {
                this.HomePriceAsNumber = this.unformat(this.HomePrice);
                this.calculateDownPayment(this.HomePriceAsNumber);
                this.getPropertyTaxesPercentChange(this.PropertyTaxesPercent);
                this.calulatePayment();
            },
            calculateByHomePrice() {
                if (this.HomePriceAsNumber !== this.unformat(this.HomePrice)) {
                    this.updateHomepriceDetails();
                }
            },
            calculateDownPayment(HomePriceLimit) {
                if (this.CreditScore === '1') {
                    this.MinDownPayment = Math.round(HomePriceLimit * 0.035);
                } else if (this.CreditScore === '2') {
                    this.MinDownPayment = Math.round(HomePriceLimit * 0.035);
                } else {
                    this.MinDownPayment = Math.round(HomePriceLimit);
                }

                this.HomePriceAsNumber = this.unformat(this.HomePrice);
                if (this.MaxDownPayment > 0 && this.HomePriceAsNumber > this.MaxDownPayment) {
                    this.updateMinDownPayment();
                    this.DownPayment = this.MinDownPayment;
                } else {
                    this.DownPaymentAsNumber = Math.round(this.HomePriceAsNumber * 0.035);
                    this.DownPayment = this.currencyWholeNumber(this.DownPaymentAsNumber);
                }
                this.DownPaymentPercent = this.DownPaymentAsNumber / this.HomePriceAsNumber * 100;
                this.DownPaymentPercent = Accounting.formatNumber(this.DownPaymentPercent, { precision: 2 });
                this.calulatePayment();
            },
            updateMinDownPayment() {
                const remainderAmount = this.HomePriceAsNumber - this.MaxDownPayment;
                if (remainderAmount > this.MinDownPayment) this.MinDownPayment = remainderAmount;
            },
            restrictDownPaymentValue() {
                this.DownPaymentAsNumber = this.unformat(this.DownPayment);
                this.HomePriceAsNumber = this.unformat(this.HomePrice);
                if (this.DownPaymentAsNumber > this.HomePriceAsNumber) {
                    this.DownPayment = 0;
                    this.$nextTick(() => {
                        this.DownPayment = this.HomePriceAsNumber;
                        this.DownPaymentAsNumber = this.HomePriceAsNumber;
                        this.calulatePayment();
                    });
                }
                this.DownPaymentPercent = this.DownPaymentAsNumber / this.HomePriceAsNumber * 100;
                this.DownPaymentPercent = Accounting.formatNumber(this.DownPaymentPercent, { precision: 2 });
                this.calulatePayment();
            },
            calculateByDownPercentage() {
                this.restrictDownPaymentValue();
            },
            calculateByDownPayment() {
                const minLimit = Math.round(this.unformat(this.HomePrice) * 0.035);
                this.maxDownpaymentError = this.DownPayment.toString().length >= 16;
                this.DownPaymentAsNumber = this.unformat(this.DownPayment);
                this.HomePriceAsNumber = this.unformat(this.HomePrice);
                if (this.MaxDownPayment > 0 && this.HomePriceAsNumber > this.MaxDownPayment) {
                    const remainderAmount = this.HomePriceAsNumber - this.MaxDownPayment;
                    if (remainderAmount > this.DownPaymentAsNumber) this.DownPayment = this.currencyWholeNumber(remainderAmount);
                    this.updateMinDownPayment();
                } else if (this.DownPaymentAsNumber < minLimit) {
                    this.DownPayment = minLimit;
                }
                this.restrictDownPaymentValue();
            },
            resetFilter() {
                this.ZipCode = this.geoLocation.zipCode;
                this.HomePrice = Accounting.formatNumber(this.homePrice);
                this.DownPayment = this.downPayment;
                this.CreditScore = this.creditScore;
                this.getLocationByZip(this.ZipCode);
                this.LoanType = this.loanType;
                this.MortgageRate = Accounting.formatNumber(this.mortgageRate, { precision: 3 });
                this.PropertyTaxes = Accounting.formatNumber(this.propertyTaxes, { precision: 2 });
                this.PropertyTaxesPercent = Accounting.formatNumber(this.propertyTaxesPercent, { precision: 2 });
                this.HomeInsurance = this.homeInsurance;
                this.HOAFees = this.hoaFees;
                this.calculateDownPayment(this.unformat(this.HomePrice));
                this.getPropertyTaxesPercentChange(this.PropertyTaxesPercent);
            },
            convertCurrency(figure) {
                return Accounting.formatNumber(Math.abs(figure));
            },
            isNegativeAmount(figure) {
                return figure < 0;
            },
            unformat(val) {
                return Accounting.unformat(val);
            },
            setPropertyTaxesAndPercent(value) {
                if (this.unformat(value) > this.HomePrice) {
                    this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                } else if (this.unformat(this.HomePrice) > this.maxValue) {
                    this.PropertyTaxes = this.maxValue;
                    this.HomePrice = this.maxValue;
                }
                this.PropertyTaxesPercent = this.getPercentageAmount(this.unformat(value));
                if (this.HomePrice !== this.InitialPropertyTax) this.calulatePayment();
                this.InitialPropertyTax = this.unformat(this.PropertyTaxes);
            },
            getPercentageAmount(value) {
                let calculatedValue = this.unformat(value) / this.unformat(this.HomePrice) * 100;
                calculatedValue = calculatedValue.toFixed(2);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : calculatedValue;
            },
            getPropertyTaxesPercentChange(value) {
                if (value <= 100) {
                    let percentValue = value;
                    percentValue = parseFloat(percentValue).toFixed(2);
                    this.PropertyTaxes = Accounting.formatNumber(this.getDollarAmount(percentValue));
                    if (this.unformat(this.PropertyTaxes) > this.unformat(this.HomePrice)) {
                        this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                    }
                    this.InitialPropertyTax = this.unformat(this.PropertyTaxes);
                } else {
                    this.PropertyTaxesPercent = 0;
                    this.PropertyTaxes = 0;
                    this.$nextTick(() => {
                        this.PropertyTaxesPercent = 100.00;
                        this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                    });
                }
            },
            getDownPaymentPercentChange() {
                if (this.DownPaymentPercent > this.downPaymentPercent) {
                    this.DownPaymentAsNumber = this.unformat(this.DownPayment);
                    this.HomePriceAsNumber = this.unformat(this.HomePrice);
                    this.DownPayment = this.DownPaymentPercent * this.HomePriceAsNumber / 100;
                    this.calulatePayment();
                } else {
                    this.DownPayment = this.downPayment;
                }
            },
            getDollarAmount(value) {
                let calculatedValue = this.unformat(value) / 100 * this.unformat(this.HomePrice);
                calculatedValue = calculatedValue.toFixed(2) % 1 === 0 ? Math.round(calculatedValue) : calculatedValue.toFixed(2);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : calculatedValue;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
